module.exports = __webpack_public_path__ + "static/media/helloBill.e207fb78.svg";